/* The providers' own marks, the same paths apps/app/src/views/Login/Login.tsx
   draws (from Lura/designs/lura-hifi-v1/auth.jsx). Copied rather than imported:
   the two workspaces share no component package. Decorative: the button's
   text already names the provider. */

export function AppleMark() {
  return (
    <svg width="17" height="17" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path
        fill="currentColor"
        d="M16.4 12.9c0-2.5 2-3.7 2.1-3.8-1.1-1.7-2.9-1.9-3.5-1.9-1.5-.1-2.8.9-3.5.9-.7 0-1.8-.8-3-.8-1.6 0-3 .9-3.8 2.4-1.6 2.8-.4 7 1.2 9.3.8 1.1 1.7 2.3 2.9 2.3 1.2 0 1.6-.7 3-.7 1.4 0 1.8.7 3 .7 1.2 0 2-1.1 2.8-2.2.6-.9.9-1.7 1.1-2.2-2.1-.8-2.3-3.4-2.3-4zM14.3 5.5c.6-.8 1.1-1.9 1-3-1 0-2.2.7-2.9 1.5-.6.7-1.2 1.8-1 2.9 1.1.1 2.2-.6 2.9-1.4z"
      />
    </svg>
  );
}

export function GoogleMark() {
  return (
    <svg width="17" height="17" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path fill="#4285F4" d="M22.5 12.2c0-.8-.1-1.4-.2-2.1H12v3.9h5.9c-.1 1-.8 2.5-1.7 3.4l-.1.1 2.8 2.2.2.1c1.8-1.6 2.9-4.1 2.9-7z" />
      <path fill="#34A853" d="M12 23c2.7 0 4.9-.9 6.5-2.4l-3.1-2.4c-.8.6-2 1-3.4 1-2.6 0-4.8-1.7-5.6-4.1l-.1.1-2.8 2.2.1.1C5.2 20.9 8.4 23 12 23z" />
      <path fill="#FBBC05" d="M6.4 15.1c-.2-.6-.3-1.3-.3-2s.1-1.4.3-2v-.1L3.5 8.7l-.1.1C2.7 10.1 2.3 11.5 2.3 13s.4 2.9 1.1 4.2l3-2.1z" />
      <path fill="#EA4335" d="M12 6.9c1.8 0 3.1.8 3.8 1.5l2.8-2.7C16.9 4.1 14.7 3 12 3 8.4 3 5.2 5.1 3.4 8.2l3 2.3C7.2 8.1 9.4 6.9 12 6.9z" />
    </svg>
  );
}
